/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CalendarEventList = {
    type: 'array',
    contains: {
        type: 'CalendarEvent',
    },
};